module.exports = __webpack_public_path__ + "img/bw.650ae10d.svg";